import React, { useState, useEffect } from 'react';
// import React from 'react';
import {
  Box,
  // Button,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import api from 'src/services/api';
import config from 'src/config';
import {
  useDispatch,
  // useSelector
} from 'react-redux';
import { setSnackbar } from 'src/redux/ducks/snackbar';
// import { setBaseDialog } from 'src/redux/ducks/baseDialog';
// import { setAccess, setAccessDetail, reloadAccess } from 'src/redux/ducks/access';
// import FormView from '../Form/FormView';
import Results from './Results';
import Toolbar from './Toolbar';

const { backendUrl } = config;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }
}));

const AccessListView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [role, setRole] = useState('');
  const [roleList, setRoleList] = useState([]);
  const [assigned, setAssigned] = useState([]);
  const [unAssigned, setUnAssigned] = useState([]);
  const [unAssignedSearch, setUnAssignedSearch] = useState('');
  const [assignedList, setAssignedList] = useState([]);
  const [unAssignedList, setUnAssignedList] = useState([]);
  const [change, setChange] = useState(0);

  const handleRoleChange = (event) => {
    setRole(event.target.value);
  };

  const handleChangeAssigned = (selected) => {
    setAssigned(selected);
    // console.log('assigned', assigned);
  };

  const handleChangeUnAssigned = (selected) => {
    setUnAssigned(selected);
  };

  const handleUnAssignedSearch = (value) => {
    setUnAssignedSearch(value);
  };

  const handleAssign = async () => {
    const accessData = unAssigned.map((v) => {
      const split = v.id.split('|');
      return {
        route: split[1],
        method: split[0],
      };
    });
    const response = await api(backendUrl).post('access/assign/access', {
      role_id: role,
      access: accessData,
    });
    const { code } = response.data;
    if (code === 200) {
      setChange(change + 1);
    }
  };

  const handleUnAssign = async () => {
    const accessData = assigned.map((v) => {
      const split = v.id.split('|');
      return {
        route: split[1],
        method: split[0],
      };
    });
    const response = await api(backendUrl).post('access/unassign/access', {
      role_id: role,
      access: accessData,
    });
    const { code } = response.data;
    if (code === 200) {
      setChange(change + 1);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api(backendUrl).get('access', {
          params: {
            role_id: role || 999999999,
          }
        });
        const { data } = response.data;
        setRoleList(data.roles);
        setAssignedList(role ? data.access[Number(role)] : []);
        setUnAssignedList(role ? data.availableRoutes : []);
        setAssigned([]);
        setUnAssigned([]);
      } catch (error) {
        dispatch(setSnackbar({ color: 'error', message: 'Fetching data failed' }));
      }
    };
    fetchData();
  }, [role, change]);

  return (
    <Page
      className={classes.root}
      title="Access"
    >
      <Container maxWidth={false}>
        <Toolbar
          role={role}
          roleList={roleList}
          handleRoleChange={handleRoleChange}
        />
        <Box mt={3}>
          <Results
            assigned={assigned}
            unAssigned={unAssigned}
            assignedList={assignedList}
            unAssignedList={unAssignedList}
            handleChangeAssigned={handleChangeAssigned}
            handleChangeUnAssigned={handleChangeUnAssigned}
            handleAssign={handleAssign}
            handleUnAssign={handleUnAssign}
            unAssignedSearch={unAssignedSearch}
            handleUnAssignedSearch={handleUnAssignedSearch}
          />
        </Box>
      </Container>
    </Page>
  );
};

export default AccessListView;
